// src/websocket/stompService.js
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

let stompClient = null;
let isConnected = false;
const subscriptions = new Map();

function initStompClient() {
  if (stompClient) return stompClient;

  stompClient = new Client({
    webSocketFactory: () => new SockJS(process.env.VUE_APP_API_URL + '/ws'),
    reconnectDelay: 5000,
    heartbeatIncoming: 10000,
    heartbeatOutgoing: 10000,
    connectHeaders: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    debug: () => {},
    onConnect: () => {
      console.log('WebSocket connected');
      isConnected = true;
      reSubscribeAll();
    },
    onStompError: (frame) => {
      console.error('STOMP error', frame);
    },
    onDisconnect: () => {
      isConnected = false;
      console.log('WebSocket disconnected');
    }
  });

  stompClient.activate();
  return stompClient;
}

function reSubscribeAll() {
  subscriptions.forEach((entry, topic) => {
    const subscription = stompClient.subscribe(topic, (msg) => {
      entry.callbacks.forEach(cb => cb(msg));
    });
    entry.subscriptions = subscription;
  });
}

export function subscribe(topic, callback) {
  const client = initStompClient();

  if (!subscriptions.has(topic)) {
    subscriptions.set(topic, {
      callbacks: [callback],
      subscription: null
    });

    if (client.connected) {
      const sub = client.subscribe(topic, (msg) => {
        subscriptions.get(topic).callbacks.forEach(cb => cb(msg));
      });
      subscriptions.get(topic).subscription = sub;
    }
  } else {
    subscriptions.get(topic).callbacks.push(callback);
  }
}

export function unsubscribe(topic, callback) {
  const entry = subscriptions.get(topic);
  if (!entry) return;

  entry.callbacks = entry.callbacks.filter(cb => cb !== callback);

  if (entry.callbacks.length === 0) {
    if (entry.subscription) {
      entry.subscription.unsubscribe();
    }
    subscriptions.delete(topic);
  } else {
    subscriptions.set(topic, entry);
  }
}

export function disconnect() {
  if (stompClient && stompClient.connected) {
    stompClient.deactivate();
    stompClient = null;
    subscriptions.clear();
    console.log('WebSocket disconnected');
  }
}
